export default __webpack_public_path__ + "static/media/orf.44efe24f.jpeg";